module.exports = __webpack_public_path__ + "static/img/15.b297ae5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/15.png
// module id = UPlC
// module chunks = 0